import React from 'react';
import { Accordion, Col, Container, Form, Row } from 'react-bootstrap';

import StepHeader from "../../../components/v2/StepHeader"
import DepartmentHeader from "../../../components/v2/DepartmentHeader";

function CompletedCheckBox(props) {
    return (
        <Form.Check
            type="checkbox"
            onChange={props.onChange}
            id={'program-' + props.programId + '_step-' + props.step}
            name={'program-' + props.programId + '_step-' + props.step}
            aria-label={props.ariaLabel}
            label={props.label}
            value={props.completed}
            defaultChecked={props.defaultChecked}
            disabled={props.disabled}
            />
    )
}

export default function AssessmentStep6(props) {

    const incompleteStepsExist = (programId) => {
        // This step cannot be completed if previous steps were not.
        if (!props.step5CompletionData[programId] ||
            !props.step5CompletionData[programId].completed) {
            return true
        }
        if (!props.step4CompletionData[programId] ||
            !props.step4CompletionData[programId].completed) {
            return true
        }
        if (!props.step3CompletionData[programId] ||
            !props.step3CompletionData[programId].completed) {
            return true
        }
        if (!props.step2CompletionData[programId] ||
            !props.step2CompletionData[programId].completed) {
            return true
        }
        if (!props.step1CompletionData[programId] ||
            !props.step1CompletionData[programId].completed) {
            return true
        }

        return false
    }

    const isFormDisabled = (programId) => {
        if (incompleteStepsExist(programId)) {
            return true
        }

        if (programId) {
            // If Step 7 was completed, we shouldn't allow 
            // edit of this step if next step is complete
            if ((programId in props.step7CompletionData) &&
                props.step7CompletionData[programId]?.completed) {
                return true
            }
        }
        return false
    }

    const prefix = 'program-'
    let allPrograms = props.department.submittedPrograms
    let filteredPrograms = []
    
    if (filteredPrograms.length == 0) {
        filteredPrograms = allPrograms.filter(function(obj) {
            return (props.activePrograms[obj.programId] == 'yes')
        })
    }

    // defaultTabs is provided to Accordion to expand all accordion items by default.
    //let defaultTabs = Array.from(props.department.submittedPrograms, (p,k) => 'program-' + k)
    let defaultTabs = []
    props.department.submittedPrograms.forEach((p) => {
        if (!(p.programId in props.step6CompletionData && props.step6CompletionData[p.programId].completed)) {
            defaultTabs.push(prefix + p.programId)
        }
    })
    
    return (
        <React.Fragment>
            <StepHeader text={props.stepTitle} />
            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    After implementing the planned changes and assessing students again, 
                    check the boxes below to indicate that assessment has been conducted 
                    and assessment data has been collected a second time in each program 
                    (degree, certificate or gen ed area).
                </div>

                <DepartmentHeader department={props.department} />

                <div className="pb-md-4 mx-auto">
                    <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                    {
                        filteredPrograms?.map((program,key) =>
                            <Accordion.Item eventKey={prefix + program.programId} key={program.programId}>
                                <Accordion.Header>
                                    {program.name} {(program.programId in props.step6CompletionData && props.step6CompletionData[program.programId].completed) ? ' - Completed' : ''}
                                </Accordion.Header>
                                <Accordion.Body>
                                    {
                                        <Container fluid>
                                            <Row>
                                                <Col></Col>
                                                <Col
                                                    md={{span: 8, offset: 3}}
                                                    lg={{span: 12, offset: 4}}
                                                    >
                                                    <CompletedCheckBox
                                                        onChange={props.onStepCompleted}
                                                        programId={program.programId}
                                                        completed={props.step6CompletionData[program.programId]?.completed}
                                                        defaultChecked={props.step6CompletionData[program.programId]?.completed}
                                                        ariaLabel="Was assessment tool used to conduct assessment a second time?"
                                                        label="Assessment has been conducted second time."
                                                        step="6"
                                                        disabled={isFormDisabled(program.programId)}
                                                        />
                                                    {incompleteStepsExist(program.programId)
                                                        ? <div className="p-3">
                                                            <span className="text-danger">
                                                                Previous step(s) must be completed before this step can be completed.
                                                            </span>
                                                          </div>
                                                        : <></>
                                                    }
                                                </Col>
                                            </Row>
                                        </Container>
                                    }
                                </Accordion.Body>
                            </Accordion.Item>
                        )
                    }
                    </Accordion>
                </div>
            </div>
        </React.Fragment>
    )
}
